// extracted by mini-css-extract-plugin
export default {"our-brands":"OurBrands_our-brands__YGDEl","brands-gallery":"OurBrands_brands-gallery__y05ap"};